import React, { PureComponent } from 'react';

import './style.css';

class ContactForm extends PureComponent {
  componentDidMount() {
    window.Formio.createForm(document.getElementById('formio'), 'https://amokwcwlxqlebqs.form.io/contactus')
      .then((form) => {
        form.on('submit', () => {
          window.location.href = window.location.origin;
        });
        form.on('error', (errors) => {
          console.error('An error has occured. Your message has not been sent.');
          console.error(errors);
        });
      });
  }

  render() {
    return (
      <div className="c-contact-form">
        <h3>Any questions or comments?</h3>
        <div id="formio" />
      </div>
    );
  }
}

export default ContactForm;



// WEBPACK FOOTER //
// ./src/pages/contact/contact-form/index.js